var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Dropdown, SplitButton } from "react-bootstrap";
import Checkbox from "@frameworks/web/components/generic/CheckBoxGeneric";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { updateChecked, } from "@frameworks/web/components/generic/FilterSidbar/GenericFilterSidebar";
import { SearchAssetTypeEnum } from "@frameworks/shared-library/components/Search/constant";
var GenericDropdownTabs = function (props) {
    var _a, _b;
    var _c = __read(React.useState(props.defaultActiveKey
        ? props.defaultActiveKey
        : props.tabsArray[0].eventKey), 2), tab = _c[0], setTab = _c[1];
    return (React.createElement(React.Fragment, null,
        !props.hideTabs && (React.createElement("div", { className: "search-toptabs-block" }, (props === null || props === void 0 ? void 0 : props.tabsArray) &&
            ((_a = props === null || props === void 0 ? void 0 : props.tabsArray) === null || _a === void 0 ? void 0 : _a.map(function (tabitem, idx) {
                var _a, _b, _c, _d, _e;
                var filterList = props.filterList.find(function (x) { return x.eventKey === tabitem.value && tabitem.filters; });
                var subTitle = "";
                var count = [];
                (_a = filterList === null || filterList === void 0 ? void 0 : filterList.list) === null || _a === void 0 ? void 0 : _a.map(function (x) {
                    if (x.selected) {
                        count.push(x.title);
                    }
                });
                if (count.length === 1) {
                    subTitle = count[0];
                }
                if (count.length > 1) {
                    subTitle = "";
                    if (tabitem.value === SearchAssetTypeEnum.Equity) {
                        subTitle = count[0] + "& ".concat(count[1]);
                    }
                    else if (tabitem.value === SearchAssetTypeEnum.MF &&
                        (count === null || count === void 0 ? void 0 : count.length) ===
                            ((_d = (_c = (_b = props.filterList) === null || _b === void 0 ? void 0 : _b.filter(function (filters) { return filters.eventKey === SearchAssetTypeEnum.MF; })[0]) === null || _c === void 0 ? void 0 : _c.list) === null || _d === void 0 ? void 0 : _d.length))
                        subTitle = "All";
                    else {
                        subTitle = count[0] + "& ".concat(count.length - 1, " more");
                    }
                }
                return (React.createElement(React.Fragment, null, !!filterList ? (React.createElement(SplitButton, { toggleLabel: " ", menuRole: "test", placement: "bottom", align: { lg: "start" }, type: "button", key: "success", id: "dropdown-split-variants-success dropdown-menu-align-responsive-2", title: tabitem.title + "".concat(!!subTitle ? ": " + subTitle : ""), onClick: function () {
                        setTab(tabitem.eventKey);
                        props.forceUpdateTab &&
                            props.forceUpdateTab(tabitem.eventKey);
                        if (props.searchString &&
                            (tabitem.value === SearchAssetTypeEnum.Option ||
                                tabitem.value === SearchAssetTypeEnum.CurOpt ||
                                tabitem.value === SearchAssetTypeEnum.ComOpt)) {
                            props.setOptions(true);
                        }
                        else {
                            props.setOptions(false);
                        }
                        props.onCallBackFunction &&
                            tabitem.value === SearchAssetTypeEnum.Equity &&
                            props.onCallBackFunction();
                    }, onToggle: function (e) {
                        if (e) {
                            setTab(tabitem.eventKey);
                            props.forceUpdateTab &&
                                props.forceUpdateTab(tabitem.eventKey);
                            // if (
                            //   props.searchString &&
                            //   (tabitem.value === SearchAssetTypeEnum.Option ||
                            //     tabitem.value === SearchAssetTypeEnum.ComOpt)
                            // ) {
                            //   props.setOptions(true);
                            // } else {
                            //   props.setOptions(false);
                            // }
                            props.onCallBackFunction &&
                                tabitem.value === SearchAssetTypeEnum.Equity &&
                                props.onCallBackFunction();
                        }
                    }, autoClose: true, className: "search-split-block ".concat(tabitem.title == tab ? "search-tab-active-btn" : "") }, (_e = filterList.list) === null || _e === void 0 ? void 0 : _e.map(function (item, id) {
                    return filterList.selectType === "checkbox" ? (React.createElement(Checkbox, { className: "common-checkbox-custom small-checkbox alignment-content", list: { display: item.title, value: item.key }, name: item.title, selected: item.selected ? item.key : "", onChange: function (e) {
                            updateChecked(e, filterList.filterName, id, props.setFilter);
                        } })) : tabitem.dropType === "radio" ? (React.createElement(React.Fragment, null)) : (React.createElement(Dropdown.Item, { onClick: function (e) {
                            updateChecked(e, filterList.filterName, id, props.setFilter, "tab");
                            // if (
                            //   tabitem.value === SearchAssetTypeEnum.Currency &&
                            //   item.key === "OPT"
                            // ) {
                            //   props.setOptions(true);
                            // } else {
                            //   props.setOptions(false);
                            // }
                        } }, item.title));
                }))) : (React.createElement("label", null,
                    React.createElement("div", { className: "search-nosplit-block hand_cursor ".concat(tabitem.title == tab
                            ? "search-tab-active-btn selected-tab-color"
                            : "") },
                        React.createElement(EdButton, { type: "button", value: tabitem.title, btnTyp: "link", onClick: function () {
                                setTab(tabitem.eventKey);
                                props.forceUpdateTab &&
                                    props.forceUpdateTab(tabitem.eventKey);
                                if (props.searchString &&
                                    (tabitem.value === SearchAssetTypeEnum.Option ||
                                        tabitem.value === SearchAssetTypeEnum.CurOpt ||
                                        tabitem.value === SearchAssetTypeEnum.ComOpt)) {
                                    props.setOptions(true);
                                }
                                else {
                                    props.setOptions(false);
                                }
                            } }))))));
            })))),
        (props === null || props === void 0 ? void 0 : props.tabsArray) &&
            ((_b = props === null || props === void 0 ? void 0 : props.tabsArray) === null || _b === void 0 ? void 0 : _b.map(function (tabs, idx) {
                return tabs.eventKey === tab && React.createElement("div", null, tabs.tabContent);
            }))));
};
export default GenericDropdownTabs;
